import { HeartIcon } from '@heroicons/react/24/outline';
import { useNavigate } from '@remix-run/react';
import cx from 'classnames';

import type { Post } from '~/interfaces/post';

import HeroChatIcon from '../Icons/HeroChatIcon';
import Typography from '../Typography';

interface Props {
  likeCount: number;
  commentCount: number;
  color?: string;
  fontFamily?: string;
  commentsEnabled?: boolean;
  post: Post;
}

const CountWrapper = ({
  count,
  children,
  className,
  color,
  fontFamily,
  onClick,
}: {
  count: number;
  className?: string;
  children: React.ReactNode;
  color?: string;
  fontFamily?: string;
  onClick?: () => void;
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    // Stopping propagation to prevent a redirect to the post.
    e.preventDefault();
    e.stopPropagation();
    onClick?.();
  };

  return (
    <button type="button" onClick={handleClick}>
      <Typography
        size="sm"
        as="span"
        fontFamily={fontFamily}
        className={cx(className, 'flex items-center space-x-1')}
        color={color}
        weight="regular"
      >
        {children}
        {count > 0 ? <span className="mt-0.5 text-xs font-bold">{count}</span> : null}
      </Typography>
    </button>
  );
};

// biome-ignore lint/correctness/noUnusedVariables: Keeping for backwards compatibility
const Insights = ({ post, likeCount, commentCount, color, fontFamily, commentsEnabled }: Props) => {
  const navigate = useNavigate();

  return (
    <div className="z-20 flex w-full items-center space-x-8 opacity-100 transition-all group-hover:opacity-100 sm:opacity-0">
      <CountWrapper count={likeCount} color={color}>
        <HeartIcon className="h-4 w-4" />
      </CountWrapper>
      {commentsEnabled && (
        <CountWrapper
          count={commentCount}
          className="mt-[2px]"
          color={color}
          onClick={() => {
            navigate(`/p/${post.slug}?comments=true`);
          }}
        >
          <HeroChatIcon className="h-4 w-4" />
        </CountWrapper>
      )}
    </div>
  );
};

export default Insights;
